import { render, staticRenderFns } from "./CreateReturnSelectType.vue?vue&type=template&id=bbd25b98&scoped=true"
import script from "./CreateReturnSelectType.vue?vue&type=script&lang=js"
export * from "./CreateReturnSelectType.vue?vue&type=script&lang=js"
import style0 from "./CreateReturnSelectType.vue?vue&type=style&index=0&id=bbd25b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd25b98",
  null
  
)

export default component.exports